import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import {
  isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser, checkAuthorizeRole,
} from '@/auth/utils'
// import apps from './routes/apps'
import pages from './routes/pages'
// import others from './routes/others'

// Role Router
import guest from './routes/guest'
import user from './routes/user'
import trainer from './routes/trainer'
import staff from './routes/staff'
import tu from './routes/tu'
import superadmin from './routes/superadmin'
import staffsekolah from './routes/staffsekolah'
import bpsdm from './routes/bpsdm'
import kadinas from './routes/kadinas'
import ketenagaan from './routes/ketenagaan'
import reflection from './routes/reflection'

Vue.use(VueRouter) 

const router = new VueRouter({
  mode: 'history',
  // base: 'simpelbptik',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    // { path: '/', redirect: { name: checkAuthorizeRole('dashboard') } },
    // ...apps,
    ...guest,
    ...user,
    ...trainer,
    ...staff,
    ...tu,
    ...superadmin,
    ...pages,
    ...staffsekolah,
    ...bpsdm,
    ...kadinas,
    ...ketenagaan,
    ...reflection,
    // ...others,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  // If auth required, check login. If login fails redirect to login page
  if (!isUserLoggedIn()) {
    const whitelist = [
      'auth-login',
      'auth-register',
      'guest-trainings.index',
      'auth-login-sso-callback',
      'validate-user-sso',
      'auth-register-sekolah',
      'verify-otp',
      'forgot-password',
      'reset-password'
    ]
    if (whitelist.includes(to.name)) {
      next()
    } else {
      next({ name: 'auth-login' })
    }
  }

  // If logged in, redirect to home page according to role
  if (to.name === 'auth-login' && isLoggedIn) {
    return next({ name: checkAuthorizeRole('dashboard') })
  }

  // If logged in, redirect to home page according to role
  if (to.meta.role && to.name !== 'guest-trainings.index') {
    if (!to.meta.role.includes(getUserData().roles[0].name.toLowerCase().replaceAll(' ', ''))) {
      return next({ name: 'misc-not-authorized' })
    }
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
